import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/components/ui/card';
import { useCreateProduct } from '../hooks/useCreateProduct';
import { ProductForm } from '../components/ProductForm';
import type { CreateProductDTO } from '../types';

export function ProductCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useCreateProduct();

  const handleSubmit = async (data: CreateProductDTO) => {
    await mutateAsync(data);
    void navigate({ to: '/dashboard/products' });
  };

  return (
    <div className="max-w-xl mx-auto space-y-6 animate-fade-in">
      <div>
        <h1 className="text-2xl font-bold text-foreground">{t('products.create')}</h1>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="text-base">{t('products.create')}</CardTitle>
        </CardHeader>
        <CardContent>
          <ProductForm mode="create" onSubmit={handleSubmit as never} isSubmitting={isPending} />
        </CardContent>
      </Card>
    </div>
  );
}
